export interface IbanCheck {
    checkiban?: string;
    code?: string;
    checksum?: string;
    bban?: string;
    country?: null | IbanCheckCountryDefinition;
    status?: IBAN_CHECK_STATUS;
    countryName?: string;
    bank?: string;
    alternativeIban?: string;
    isAlternativeIban?: boolean;
    account?: string;
    iban?: string;
}

export interface IbanCheckWithErrors extends IbanCheck {
    error?: string | null;
    errorCode?: 0 | string | null;
    advice?: null | string;
}

export enum IBAN_CHECK_STATUS {
    NO_IBAN = -100, // Can't be an IBAN
    IBAN_ERROR = -50, // Real Error in IBAN
    INCOMPLETE = 0, // Incomplete IBAN (display Advice)
    SUCCESS = 10, // Correct IBAN
}

export interface IbanCheckCountryDefinition {
    name: string;
    code: string;
    bank: [number, string][];
    acc: [number, string][];
    bankLength: number;
    accountLength: number;
    totalLength: number;
    maskInputFormat: string;
    sepa: boolean;
}
